import cn from "classnames";
import { BackgroundColorClassName } from "@/constants/style";
import { ColorVariant } from "@/constants/theme";

export function getBackgroundColorClassName(color: ColorVariant) {
  return cn({
    [BackgroundColorClassName.BLACK]: color === ColorVariant.Black,
    [BackgroundColorClassName.WHITE]: color === ColorVariant.White,
    [BackgroundColorClassName.BRAND_PRIMARY]: color === ColorVariant.Primary,
    [BackgroundColorClassName.BRAND_SECONDARY]:
      color === ColorVariant.Secondary,
    [BackgroundColorClassName.BRAND_ACCENT]: color === ColorVariant.Accent,
    [BackgroundColorClassName.BRAND_CONTRAST]:
      color === ColorVariant.BrandContrast,
    [BackgroundColorClassName.STANDARD_MAIN]: color === ColorVariant.Main,
    [BackgroundColorClassName.STANDARD_DARK]: color === ColorVariant.Dark,
    [BackgroundColorClassName.STANDARD_LIGHT]: color === ColorVariant.Light,
    [BackgroundColorClassName.STANDARD_CONTRAST]:
      color === ColorVariant.StandardContrast,
    [BackgroundColorClassName.ALERT_SUCCESS]: color === ColorVariant.Success,
    [BackgroundColorClassName.ALERT_WARNING]: color === ColorVariant.Warning,
    [BackgroundColorClassName.ALERT_ERROR]: color === ColorVariant.Error,
    [BackgroundColorClassName.ALERT_INFO]: color === ColorVariant.Info,
    [BackgroundColorClassName.CUSTOM_1]: color === ColorVariant.Custom1,
    [BackgroundColorClassName.CUSTOM_2]: color === ColorVariant.Custom2,
    [BackgroundColorClassName.CUSTOM_3]: color === ColorVariant.Custom3,
    [BackgroundColorClassName.CUSTOM_4]: color === ColorVariant.Custom4,
  });
}
